import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { TaskDtoKeysEnum } from '@zaoblako/shared/modules/task/enum/task-dto-keys.enum';

import * as yup from 'yup';

export interface TaskStatusFormSettingsItemInterface {
  /** Field origin or display name (if display name decorator was applied) */
  name: string;
  /** Is this property editable for this status type */
  editable: boolean;
  /** Is this property required (cannot be `null` or `undefined`) for this status type */
  required: boolean;
  /** Is this property visible in the interface */
  visible: boolean;
}

export const TaskStatusFormSettingsItemDto = SerdeDtoClass.create<TaskStatusFormSettingsItemInterface>(TaskDtoKeysEnum.TASKS_STATUS_FORM_SETTINGS_ITEM_FIND_DTO, {
  name: {
    label: 'Номер',
    serializer: yup.string(),
  },
  editable: {
    label: 'Редактируемое',
    serializer: yup.boolean(),
  },
  required: {
    label: 'Обязательное',
    serializer: yup.boolean(),
  },
  visible: {
    label: 'Видимое',
    serializer: yup.boolean(),
  },
});
